import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React, { useCallback, useEffect } from "react";
import InitiateAClaim from "../../../../Components/Broker/Claim/InitiateAClaimSp/InitiateAClaim";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
// import InitiateAClaim from "../../../../Components/Broker/Claim/InitiateAClaim/InitiateAClaim";
import { useNavigate } from "react-router-dom";
import ViewDocuments from "../../../../Components/Broker/Claim/ViewDocuments/ViewDocuments";
import SearchBox from "../../../../Components/Broker/SearchBarAnimation/SearchBox";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import UGDateRangePicker from "../../../../Supporting files/UGDateRangePicker/UGDateRangePicker";
import "./Claimassistant.scss";

interface Props {
  intiateClaim: boolean;
}

const Claimassistant: React.FC<Props> = ({ intiateClaim }) => {
  const [addFilter, setAddFilter] = React.useState(false);
  const [policyType, setPolicyType] = React.useState("");
  const [policyname, setPolicyName] = React.useState("");
  const [expiry, setExpiryStatus] = React.useState("");
  const [relation, setRelation] = React.useState("");
  const [selectDocument, setSelectDocument] = React.useState("");
  const [InitiateACliam, setInitiateACliam] = React.useState(intiateClaim);
  const [viewDocuments, setViewDocuments] = React.useState(false);
  const [priorityStatus, setPriorityStatus] = React.useState("Approved");

  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "policyType") {
      setPolicyType(event.target.value as string);
    } else if (attrName === "expiry") {
      setExpiryStatus(event.target.value as string);
    } else if (attrName === "policyname") {
      setPolicyName(event.target.value as string);
    } else if (attrName === "relation") {
      setRelation(event.target.value as string);
    }
  };
  const prioritystatusData = [
    { key: "Approved", value: "Approved" },
    { key: "Rejected", value: "Rejected" },
    { key: "Pending", value: "Pending With Insurer" },
    { key: "Sent_To_Insurer", value: "Sent To Insurer" },
    { key: "Documents Pending", value: "Documents Pending" },
  ];

  useEffect(() => {
    // attach the event listener
    window.addEventListener("keydown", handleKeyPress);
  }, []);

  const handleKeyPress = useCallback((e: any) => {
    var event = e;
    if (event.target.tagName !== "INPUT") {
      if (event.shiftKey && event.keyCode == 76) {
        setInitiateACliam(true);
      }
    }
  }, []);
  const navigate = useNavigate();

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "claim_id",
      headerName: "Claim ID",
      minWidth: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/ClaimAssistantDetail");
            }}
          >
            {row.claim_id}
          </Link>
        );
      },
    },
    {
      field: "client_id",
      headerName: "Client ID",
      minWidth: 150,
      check_status: true,
    },
    {
      field: "client_name",
      headerName: "Client Name",
      minWidth: 200,
      check_status: true,
    },
    {
      field: "emp_id",
      headerName: "Member ID",
      minWidth: 150,
      check_status: true,
    },
    {
      field: "emp_name",
      headerName: "Member Name",
      minWidth: 200,
      check_status: true,
    },
    {
      field: "designation",
      headerName: "Designation",
      minWidth: 150,
      check_status: true,
    },
    {
      field: "department",
      headerName: "Department",
      minWidth: 150,
      check_status: true,
    },
    {
      field: "policy_number",
      headerName: "Policy Number",
      minWidth: 250,
      check_status: true,
    },
    {
      field: "policy_type",
      headerName: "Policy Type",
      minWidth: 250,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {/* {priorityStatus === "Highest" || priorityStatus === "Active" ? (
              <CheckCircleIcon id={priorityStatus} />
            ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
              <CancelIcon id={priorityStatus} />
            ) : priorityStatus == "Pending" ? (
              <HourglassTopIcon id={priorityStatus} />
            ) : priorityStatus == "Inprogress" ? (
              <PublishedWithChangesIcon id={priorityStatus} />
            ) : priorityStatus == "Expired" ? (
              <HistoryToggleOffIcon id={priorityStatus} />
            ) : null} */}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "req_type",
      headerName: "Request Type",
      minWidth: 150,
      check_status: true,
    },
    {
      field: "insured_person",
      headerName: "Insured Person",
      minWidth: 150,
      check_status: true,
    },
    {
      field: "document",
      headerName: "Document",
      minWidth: 100,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            sx={{ textDecoration: "none" }}
            onClick={() => {
              setViewDocuments(true);
            }}
          >
            <span
              style={{
                color: "#000000",
                textDecoration: "none",
                marginRight: "10px",
              }}
            >
              {row.document}
            </span>
            <img
              src="images/visibility-icon.svg"
              alt=""
              style={{ zIndex: 99, position: "relative", cursor: "pointer" }}
            />
          </Link>
        );
      },
    },
  ]);
  const rows = [
    {
      id: 0,
      claim_id: "CLM001",
      client_id: "CL001",
      client_name: "Evervent",
      emp_id: "EV001",
      emp_name: "Uday Kumar",
      designation: "VP",
      department: "IT",
      policy_number: "PB1562",
      policy_type: "Group Health Insurance",
      status: "Approved",
      req_type: "Cashless Request",
      insured_person: "Uday Kumar",
      document: 8,
    },
    {
      id: 1,
      claim_id: "CLM002",
      client_id: "CL001",
      client_name: "Evervent",
      emp_id: "EV001",
      emp_name: "Uday Kumar",
      designation: "VP",
      department: "IT",
      policy_number: "PB1563",
      policy_type: "Group Health Insurance",
      status: "Approved",
      req_type: "Claim Intimation",
      insured_person: "Uday Kumar",
      document: 16,
    },
    {
      id: 2,
      claim_id: "CLM003",
      client_id: "CL001",
      client_name: "Evervent",
      emp_id: "EV001",
      emp_name: "Uday Kumar",
      designation: "VP",
      department: "IT",
      policy_number: "PB1564",
      policy_type: "Group Health Insurance",
      status: "Approved",
      req_type: "Cashless Request",
      insured_person: "Uday Kumar",
      document: 45,
    },
    {
      id: 3,
      claim_id: "CLM004",
      client_id: "CL001",
      client_name: "Evervent",
      emp_id: "EV001",
      emp_name: "Uday Kumar",
      designation: "VP",
      department: "IT",
      policy_number: "PB1565",
      policy_type: "Group Health Insurance",
      status: "Approved",
      req_type: "Claim Intimation",
      insured_person: "Uday Kumar",
      document: 2,
    },
    {
      id: 4,
      claim_id: "CLM005",
      client_id: "CL001",
      client_name: "Evervent",
      emp_id: "EV001",
      emp_name: "Uday Kumar",
      designation: "VP",
      department: "IT",
      policy_number: "PB1566",
      policy_type: "Group Health Insurance",
      status: "Approved",
      req_type: "Cashless Request",
      insured_person: "Uday Kumar",
      document: 18,
    },
  ];

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
    setPriorityStatus(value);
  };
  console.log(priorityStatus);
  return (
    <Grid container spacing={2} className="claimAssistant">
      <InitiateAClaim
        attrName={setInitiateACliam}
        open_status={InitiateACliam}
        value_update={updateMasterState}
        client_id_status={true}
      />
      <ViewDocuments
        attrName={setViewDocuments}
        open_status={viewDocuments}
        value_update={updateMasterState}
      />
      <Modal
        open={addFilter}
        onClose={() => {
          setAddFilter(false);
        }}
        className="modalWrapper"
      >
        <Box className="modalInner">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Link
                className="close-button"
                onClick={() => setAddFilter(false)}
              ></Link>
              <h5 className="popup-heading">Add Filters</h5>
            </Grid>
          </Grid>
          <Grid container spacing={2} className="mb-3">
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Claim Id</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectDocument}
                  label="Claim Id"
                  onChange={(e) => handleChange(e, "selectDocument")}
                >
                  <MenuItem value={"aadhar"}>Aadhar Card</MenuItem>
                  <MenuItem value={"pan"}>PAN</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Client ID</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Client ID"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Emp ID</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Emp ID"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="Employee Name"
                variant="outlined"
                className="textarea"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Designation
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Designation"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2} className="mb-3">
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Department
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Department"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Policy Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Request Type"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Status"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Request Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Request Type"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Insured Person
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relation}
                  label="Insured Person"
                  onChange={(e) => handleChange(e, "relation")}
                >
                  <MenuItem value={"i"}>ICICI</MenuItem>
                  <MenuItem value={"h"}>HDFC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              className="ctaBtn"
              style={{ textAlign: "center" }}
            >
              <Button variant="contained" className="submitBtn">
                Apply
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
        <h3 className="mb-0 mr-3">Claim Assistant </h3>
        <SearchBox />
      </Grid>
      <Grid item xs={6} className="text-right">
        <UGDateRangePicker
          minDate={new Date()}
          maxDate={new Date()}
          placement="bottom"
        />
        {/* <Link
          
          underline="none"
          className="blackBtn settings"
          onClick={() => {
            setAddFilter(true);
          }}
        >
          Filter
        </Link> */}
        <Link
          underline="none"
          className="greenBtn docs"
          onClick={() => {
            setInitiateACliam(true);
          }}
        >
          Intiate a claim
        </Link>
      </Grid>
      <Grid item xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
};

export default Claimassistant;
